<template>
  <div class="menu-wrapper">
    <!-- 菜单栏折叠 -->
    <template v-if="collapse">
      <!-- 无子菜单 -->
      <el-menu-item v-if="this.item.children == 0" :index="item.id.toString()">
        <svg-icon :icon-class="this.item.meta.icon"></svg-icon>
        <span slot="title">{{ $t(this.item.meta.title) }}</span>
      </el-menu-item>
      <!-- 有子菜单 -->
      <el-menu-item
        v-else
        :index="item.id.toString()"
        @click="handleSelectMenu(item)"
      >
        <svg-icon :icon-class="this.item.meta.icon"></svg-icon>
      </el-menu-item>
    </template>
    <!-- 菜单栏不折叠 -->
    <el-submenu v-else :index="this.item.path.toString()" ref="subMenu">
      <template slot="title">
        <svg-icon :icon-class="this.item.meta.icon"></svg-icon>
        <span
          slot="title"
          v-show="!collapse"
          style="display: inline-block; padding: 0"
          >{{ $t(this.item.meta.title) }}</span
        >
      </template>
      <template v-for="child in item.children">
        <div
          v-if="child.children && child.children.length > 0"
          :key="child.path"
        >
          <sidebar-item :item="child" :key="child.path" />
        </div>

        <div v-else :key="child.path">
          <div v-if="!child.iframe">
            <el-menu-item :key="child.path" :index="child.path.toString()">
              <svg-icon :icon-class="child.meta.icon"></svg-icon>
              <span slot="title" style="display: inline-block; padding: 0">
                {{ $t(child.meta.title) }}</span
              >
            </el-menu-item>
          </div>
          <div v-if="child.iframe">
            <el-menu-item @click="changeTo(child)">
              <svg-icon :icon-class="child.meta.icon"></svg-icon>
              <span slot="title" style="display: inline-block; padding: 0">
                {{ $t(child.meta.title) }}</span
              >
            </el-menu-item>
          </div>
        </div>
      </template>
    </el-submenu>
  </div>
</template>

<script>
import FixiOSBug from "./FixiOSBug";
import bus from "./eventBus";
// import AppLink from "./Link";
// import path from "path-browserify";
export default {
  name: "SidebarItem",
  components: {
    // AppLink,
  },
  mixins: [FixiOSBug],
  props: {
    item: {
      type: Object,
      required: true,
    },
    collapse: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      menuList: {},
    };
  },
  mounted() {
    if (this.item.children) {
      this.item.children.forEach((item, index, array) => {
        if (item.hidden == true) {
          array.splice(index, 1);
        }
      });
    }
  },
  methods: {
    changeTo(routePath) {
      window.open(routePath.path);
      // return path.resolve(this.basePath, routePath);
    },

    getRouterList(item) {
      bus.$emit("secondList", item.children);
    },
    handleSelectMenu(item) {
      if (this.$route.matched[0].name == item.name) {
        return;
      }
      while (1) {
        if (item.hasOwnProperty("children")) {
          item = item.children[0];
        }
        if (!item.hasOwnProperty("children")) {
          if (item.iframe) {
            this.changeTo(item);
          } else {
            this.$router.push({ path: item.path });
          }
          break;
        }
      }
    },
  },
};
</script>
<style>
.el-menu-item {
  width: 100%;
  color: rgb(255, 255, 255) !important;
  background-color: transparent !important;
}
.el-menu-item:hover {
  padding: 0 !important;
  color: #ffffff !important;
  width: 100%;
}

.el-submenu__title {
  padding: 0 !important;
  color: rgb(255, 255, 255) !important;
}
.el-submenu__title i {
  color: rgb(255, 255, 255) !important;
}
.el-submenu__title:hover {
  padding: 0 !important;
  color: #ffffff !important;
}
.el-menu--vertical .el-menu-item {
  width: 100%;
  padding-left: 20px;
}
.el-menu--vertical .el-menu--popup .el-menu-item:hover {
  padding-left: 10px !important;
}
/*设置图标颜色  */
.menu-wrapper .svg-icon {
  width: 50px;
  height: 25px;
  margin-left: 5px;
  margin-right: 20px;
  color: rgb(83, 83, 83);
  vertical-align: middle;
}
.menu-wrapper .is-active .svg-icon {
  width: 50px;
  height: 25px;
  color: rgb(255, 255, 255);
}
.el-submenu .is-active {
  border-left: 2px solid white;
}
.menu-wrapper {
  width: 225px;
}
.el-menu-item {
  padding-left: 0px !important;
}
</style>
